import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserDataService } from '../user-data.service';
import {Observable} from "rxjs";
import {take, map, tap} from 'rxjs/operators';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private afAuth: UserDataService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.afAuth.getMainData().pipe(
            take(1),
            map(user => !!user),
            tap(loggedIn => {
                
                if (!loggedIn) {
                    this.router.navigate(['/autentificare']);
                }else{
                    this.afAuth.getMainData().subscribe((currentUser:any)=>{
                        console.log('GUARD DATA', currentUser);
                        if(currentUser.roles[0]==="ROLE_JobBoardsCandidate" && this.router.url==="/adauga-job"){
                            this.router.navigate(['/']);
                        }
                    })
                }
            },
             error => {
                this.router.navigate(['/autentificare']);
            })
        );
    }

}